import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { MarketingVoucherContainer } from "@/components/features/marketing/voucher/top/ui/container";

import { useGetVoucherTopPageParams } from "./_hooks/use-get-voucher-top-page-params";

export const MarketingVoucherTopPage = () => {
	const { hotelID } = useGetVoucherTopPageParams();

	return (
		<PageMeta title="宿泊券の一覧" url={generatePath(PATHS.HOTEL.MARKETING.VOUCHER.TOP, { hotelID })}>
			<MarketingVoucherContainer hotelID={hotelID} />
		</PageMeta>
	);
};

MarketingVoucherTopPage.displayName = "MarketingVoucherTopPage";
